import React, { Fragment } from "react";
import { withStyles } from "material-ui/styles";
import TotalResultByAttributes from "components/ReportDetail/TotalResultByAttributes.jsx";
import QuestionRanking from "components/ReportDetail/QuestionRanking";
import CorrelationCoefficientRanking from "components/ReportDetail/CorrelationCoefficientRanking";
import ErrorMessage from "components/ErrorMessage";
import CircularProgress from "material-ui/Progress/CircularProgress";
import { Button } from "material-ui";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  reportTitle: { fontSize: 30, textAlign: "center" },
  chapter: {
    paddingTop: 70,
    paddingLeft: 20
  },
  chapterTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center"
  },
  section: {
    paddingLeft: 20
  },
  sectionTitle: {
    fontWeight: 600,
    display: "inline-block"
  },
  result: {
    marginBottom: 50
  },
  errorMessage: {
    margin: 10
  },
  rankBtn: {
    margin: 10,
    textDecoration: "none",
    width: 200,
    float: "right"
  }
});

const makeGraph = (data, classes) => (
  <Fragment key={data.title}>
    <div className={classes.result}>
      <span className={classes.sectionTitle}>{data.title}</span>
      <TotalResultByAttributes
        data={data.data}
        xCategories={data.xCategories}
      />
    </div>
  </Fragment>
);

class BasicReport extends React.Component {
  componentWillMount() {
    this.props.fetchBasicReport();
  }
  componentWillUnmount() {
    this.props.initBasicReport();
  }
  render() {
    const { classes, basicReport } = this.props;
    const {
      totalResultByAttr,
      questionRanking,
      correlationCoefficientRanking,
      errors
    } = basicReport;
    if (errors.length > 0) {
      return (
        <ErrorMessage messages={errors} className={classes.errorMessage} />
      );
    }
    if (totalResultByAttr.length === 0) {
      return (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 100 }}
        >
          <CircularProgress size={100} />
        </div>
      );
    }
    return (
      <div style={{ padding: 30, backgroundColor: "white" }}>
        <div className={classes.reportTitle}>NiserES 調査結果 添付資料</div>
        <div>
          <a href="#questionRanking" className={classes.rankBtn}>
            <Button>▼設問ランキング</Button>
          </a>
        </div>
        {/* 属性別集計結果 */}
        <section className={classes.chapter} id="summary">
          {totalResultByAttr.map(v => makeGraph(v, classes))}
        </section>
        {/* 設問ランキング */}
        <section className={classes.chapter} id="questionRanking">
          <div className={classes.chapterTitle}>
            【補足資料】<br />設問ランキング
          </div>
          <QuestionRanking
            consData={questionRanking.consData}
            prosData={questionRanking.prosData}
          />
        </section>
        {/* 相関係数ランキング */}
        <section className={classes.chapter} id="ranking">
          <div className={classes.chapterTitle}>相関係数ランキング</div>
          {correlationCoefficientRanking === null ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <span>集計に必要なデータが不足しているため表示できません。</span>
            </div>
          ) : (
            <CorrelationCoefficientRanking
              firstData={correlationCoefficientRanking.firstData}
              secondData={correlationCoefficientRanking.secondData}
            />
          )}
        </section>
      </div>
    );
  }
}

export default withStyles(styles)(BasicReport);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/BasicReport.jsx